<!-- ============ LANDING VIEW ============ -->
<ng-container *ngIf="view === 'landing'">
  <header class="bar">
    <div class="wrap">
      <div class="logos">
        <img src="assets/maccabi/maccabi-logo.svg" class="logo-maccabi" [alt]="'patientPortal.alt.maccabi' | translate" />
        <div class="logo-sep"></div>
        <img src="assets/maccabi/markable-logo.png" class="logo-markable" alt="MARKABLE" />
      </div>
      <div class="bar-tag" [innerHTML]="'patientPortal.bar.tag' | translate"></div>
    </div>
  </header>

  <section class="hero">
    <div class="wrap">
      <div class="hero-text">
        <span class="eyebrow"><span class="dot"></span>{{ 'patientPortal.hero.eyebrow' | translate }}</span>
        <h1>
          <span class="uname" *ngIf="firstName">{{ firstName }}, </span><span [innerHTML]="'patientPortal.hero.h1' | translate"></span>
        </h1>
        <p class="lead">{{ 'patientPortal.hero.lead' | translate }}</p>
        <div class="cta-row">
          <button type="button" class="btn" (click)="goToConsent()">
            {{ 'patientPortal.hero.cta' | translate }}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
          </button>
          <span class="cta-note" [innerHTML]="'patientPortal.hero.ctaNote' | translate"></span>
        </div>
      </div>

      <div class="media">
        <div class="glow"></div>
        <div class="media-card">
          <video #heroVideo autoplay muted [muted]="true" loop playsinline poster="assets/maccabi/facescan-hero-poster.jpg" preload="auto">
            <source src="assets/maccabi/facescan-hero-mesh.mp4" type="video/mp4" />
            <img src="assets/maccabi/facescan-hero-poster.jpg" class="cover" [alt]="'patientPortal.alt.scan' | translate" />
          </video>
          <div class="chips">
            <span class="chip"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2.2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>{{ 'patientPortal.chips.minutes' | translate }}</span>
            <span class="chip"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2.2"><path d="M3 9l9-6 9 6v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>{{ 'patientPortal.chips.oneSelfie' | translate }}</span>
            <span class="chip"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2.2"><path d="M18 6 6 18M6 6l12 12" /></svg>{{ 'patientPortal.chips.noNeedles' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- what it includes -->
  <section>
    <div class="wrap">
      <div class="sec-head">
        <div class="kicker">{{ 'patientPortal.includes.kicker' | translate }}</div>
        <h2>{{ 'patientPortal.includes.title' | translate }}</h2>
        <p class="sec-sub">{{ 'patientPortal.includes.sub' | translate }}</p>
      </div>
      <div class="steps-band">
        <div class="steps">
          <div class="step">
            <div class="step-num">1</div>
            <div>
              <div class="step-t">{{ 'patientPortal.includes.step1t' | translate }}</div>
              <div class="step-d">{{ 'patientPortal.includes.step1d' | translate }}</div>
            </div>
          </div>
          <div class="step">
            <div class="step-num">2</div>
            <div>
              <div class="step-t">{{ 'patientPortal.includes.step2t' | translate }}</div>
              <div class="step-d">{{ 'patientPortal.includes.step2d' | translate }}</div>
            </div>
          </div>
          <div class="step">
            <div class="step-num">3</div>
            <div>
              <div class="step-t"><span dir="ltr">THINK</span><span class="tm">&trade;</span></div>
              <div class="step-d" [innerHTML]="'patientPortal.includes.step3d' | translate"></div>
            </div>
          </div>
          <div class="step">
            <div class="step-num">4</div>
            <div>
              <div class="step-t"><span dir="ltr">SENSE</span><span class="tm">&trade;</span></div>
              <div class="step-d" [innerHTML]="'patientPortal.includes.step4d' | translate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- what's in it for her -->
  <section style="padding-top: 14px">
    <div class="wrap">
      <div class="sec-head">
        <div class="kicker">{{ 'patientPortal.benefits.kicker' | translate }}</div>
        <h2>{{ 'patientPortal.benefits.title' | translate }}</h2>
      </div>
      <div class="bene">
        <div class="card">
          <div class="ico"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2"><circle cx="5" cy="6" r="2" /><circle cx="19" cy="9" r="2" /><circle cx="9" cy="18" r="2" /><path d="M6.7 6.7 17 8.5M17.5 10.6 10.4 16.4M7.5 16.2 5.4 8" /></svg></div>
          <h3>{{ 'patientPortal.benefits.card1t' | translate }}</h3>
          <p>{{ 'patientPortal.benefits.card1d' | translate }}</p>
        </div>
        <div class="card">
          <div class="ico"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" /></svg></div>
          <h3>{{ 'patientPortal.benefits.card2t' | translate }}</h3>
          <p>{{ 'patientPortal.benefits.card2d' | translate }}</p>
        </div>
        <div class="card">
          <div class="ico"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg></div>
          <h3>{{ 'patientPortal.benefits.card3t' | translate }}</h3>
          <p>{{ 'patientPortal.benefits.card3d' | translate }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- reassurance + cta -->
  <section style="padding-top: 6px">
    <div class="wrap">
      <div class="reassure">
        <div class="lock"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke-width="1.8"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg></div>
        <div>
          <h3>{{ 'patientPortal.reassure.title' | translate }}</h3>
          <p>{{ 'patientPortal.reassure.body' | translate }}</p>
        </div>
        <button type="button" class="btn btn-close" (click)="goToConsent()">
          {{ 'patientPortal.hero.cta' | translate }}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
        </button>
      </div>
    </div>
  </section>

  <footer>
    <div class="wrap">
      <p class="disc">{{ 'patientPortal.footer.disc' | translate }}</p>
      <p class="rights"><span dir="ltr">Patent Pending &middot; MARKABLE&trade; Ltd. &middot; All rights reserved</span> &middot; {{ 'patientPortal.footer.partner' | translate }}</p>
    </div>
  </footer>
</ng-container>

<!-- ============ CONSENT VIEW ============ -->
<ng-container *ngIf="view === 'consent'">
  <header class="bar">
    <div class="wrap">
      <div class="logos">
        <img src="assets/maccabi/maccabi-logo.svg" class="logo-maccabi" [alt]="'patientPortal.alt.maccabi' | translate" />
        <div class="logo-sep"></div>
        <img src="assets/maccabi/markable-logo.png" class="logo-markable" alt="MARKABLE" />
      </div>
      <button type="button" class="back-link" (click)="backToLanding()">{{ 'patientPortal.consent.back' | translate }}</button>
    </div>
  </header>

  <section class="consent">
    <div class="consent-wrap">
      <h1 class="consent-title">{{ 'patientPortal.consent.title' | translate }}</h1>
      <p class="consent-intro">{{ 'patientPortal.consent.intro' | translate }}</p>

      <label class="consent-row consent-master">
        <input type="checkbox" [ngModel]="approveRequired" (ngModelChange)="onApproveRequiredChange($event)" />
        <span>{{ 'patientPortal.consent.approveRequired' | translate }}</span>
      </label>

      <div class="consent-list">
        <label class="consent-row">
          <input type="checkbox" [(ngModel)]="consentRequiredData" (ngModelChange)="onRequiredBoxChange()" />
          <span><b class="req">{{ 'patientPortal.consent.requiredTag' | translate }}</b> {{ 'patientPortal.consent.cb1' | translate }}</span>
        </label>

        <label class="consent-row">
          <input type="checkbox" [(ngModel)]="consentResearch" />
          <span><b class="opt">{{ 'patientPortal.consent.optionalTag' | translate }}</b> {{ 'patientPortal.consent.cb2' | translate }}</span>
        </label>

        <label class="consent-row">
          <input type="checkbox" [(ngModel)]="consentPrivacy" (ngModelChange)="onRequiredBoxChange()" />
          <span><b class="req">{{ 'patientPortal.consent.requiredTag' | translate }}</b> {{ 'patientPortal.consent.cb3' | translate }}</span>
        </label>
      </div>

      <button type="button" class="btn portal-start-btn" [disabled]="!canStart" (click)="startTest()">
        {{ 'patientPortal.consent.cta' | translate }}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
      </button>
      <p class="consent-note">{{ 'patientPortal.consent.note' | translate }}</p>
    </div>
  </section>
</ng-container>
